<div class="modal-overlay" *ngIf="show" (click)="onOverlayClick($event)">
    <div class="modal-container" [style.maxWidth.px]="width">

        <header class="modal-header">
            <h3 class="modal-title">{{ title }}</h3>
            <button type="button" class="modal-close" (click)="close()" aria-label="Cerrar">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                    <path d="M18 6L6 18M6 6l12 12" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
        </header>

        <div class="modal-body">
            <ng-content></ng-content>
        </div>

        <footer class="modal-footer">
            <ng-content select="[modal-footer]"></ng-content>
        </footer>

    </div>
</div>
